import React from "react";
import HeroImage from "../../Images/Hero-image.jpg";
import "./Digicloud.css";
import hrProductImage from "../../Images/hr-section-digicloud.png";
import clientSuccess from "../../Images/client-success-digicloud.png";
import ContactUs from "../ContactUs1";

const Digicloud = () => {
  const solutions = [
    {
      number: "1",
      title: "Streamlined HR Processes",
      description:
        "Automate and simplify your HR operations, from onboarding to performance management, with our comprehensive HRMS solution.",
    },
    {
      number: "2",
      title: "Enhanced Employee Engagement",
      description:
        "Boost employee engagement and satisfaction with tools for feedback, recognition, and professional development.",
    },
    {
      number: "3",
      title: "Data-Driven Insights",
      description:
        "Gain valuable insights into your workforce with detailed analytics and reporting, enabling informed decision-making.",
    },
  ];

  const successStories = [
    {
      number: "1",
      title: "Efficient Candidate Sourcing",
      description:
        "Find the best talent quickly and easily with our advanced search and filtering capabilities.",
    },
    {
      number: "2",
      title: "Collaborative Hiring Process",
      description:
        "Collaborate with your team on candidate evaluations and hiring decisions, ensuring a streamlined and effective process.",
    },
    {
      number: "3",
      title: "Seamless Integration",
      description:
        "Integrate with your existing HR systems and workflows for a seamless recruitment experience.",
    },
  ];

  return (
    <div className="digicloud">
      <section className="hero-section">
        <div className="left-section">
          <h1 className="hero-heading">
            DigiCloud Tech Services: Your All-in-One SaaS Solutions Partner
          </h1>
          <p className="hero-paragraph">
            Empowering businesses with cutting-edge SaaS <br />
            solutions tailored to drive growth and efficiency. <br /> Discover
            how DigiCloud can transform your operations.
          </p>
        </div>
        <div>
          <img src={HeroImage} alt="herp-image" className="hero-image"></img>
        </div>
      </section>

      <section className="secondary-section">
        <div className="secondary-top-section">
          <h1 className="secondary-heading">
            About DigiCloud: Innovating Business Solutions from Bangalore &
            Madurai{" "}
          </h1>
          <div className="secondary-below-section">
            <div className="secondary-sub-section">
              <h1 className="secondary-below-section-heading"> Our Mission</h1>
              <p className="secondary-paragraph">
                To empower businesses with innovative, scalable, and
                user-friendly SaaS solutions. Based in Bangalore & Madurai, we
                deliver exceptional value and drive tangible results.
              </p>
            </div>
            <div className="secondary-sub-section">
              <h1 className="secondary-below-section-heading">Our Vision </h1>
              <p className="secondary-paragraph">
                To be the leading SaaS provider in India, recognized for our
                commitment to customer success and our ability to transform
                businesses through technology.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="product-suite">
        <div className="product-container">
          <h2 className="product-heading">
            Our SaaS Products: Streamlining Your Business Operations{" "}
          </h2>
          <div className="features">
            <div className="feature">
              <span className="feature-number">1</span>
              <div>
                <h3 className="feature-title">Comprehensive Solutions</h3>
                <p>
                  We offer a suite of SaaS products designed to cover all your
                  business needs, from HR to recruitment to software management.{" "}
                </p>
              </div>
            </div>
            <div className="feature">
              <span className="feature-number">2</span>
              <div>
                <h3 className="feature-title">Scalable & Flexible</h3>
                <p>
                  Our solutions are designed to grow with your business,
                  providing the flexibility and scalability you need to succeed
                  in today's dynamic market.
                </p>
              </div>
            </div>
            <div className="feature">
              <span className="feature-number">3</span>
              <div>
                <h3 className="feature-title">User-Friendly Interface</h3>
                <p>
                  With intuitive interfaces and easy-to-use features, our
                  products ensure seamless adoption and maximum efficiency for
                  your team.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="hr-product-spotlight">
        <div className="hr-product-container">
          <div className="hr-content">
            <h2 className="hr-heading">
              OurDept.in: The Marketplace for All Your Company Software Needs
            </h2>
            <div className="hr-features">
              <div className="hr-feature">
                <h3>Extensive Selection</h3>
                <p>
                  Browse a wide range of software solutions tailored to meet the
                  unique needs of your business, all in one convenient
                  marketplace.
                </p>
              </div>
              <div className="hr-feature">
                <h3>Competitive Pricing</h3>
                <p>
                  Find the best deals and pricing options on the market,
                  ensuring you get the most value for your investment in
                  software.
                </p>
              </div>
            </div>
            <div className="third-container">
              <div className="hr-feature">
                <h3>Simplified Procurement</h3>
                <p>
                  Streamline your software procurement process with our
                  easy-to-use platform, saving you time and resources.
                </p>
              </div>
            </div>
          </div>
          <div className="image-container">
            <img src={hrProductImage} alt="HR Software Dashboard" />
          </div>
        </div>
      </section>

      <section className="employee-management">
        <div className="  py-16 px-8 shadow-lg">
          <h2 className="text-5xl font-bold text-center">
            myHRdept.in: Complete HRMS Solutions for Enhanced Employee
            Management.
          </h2>
          <div className="mt-10 flex flex-col items-center gap-8 relative w-full">
            {/* Continuous Vertical Line */}
            <div className="absolute top-0 bottom-0 w-[2px] bg-gray-500 left-1/2 transform -translate-x-1/2"></div>

            {solutions.map((solution, index) => (
              <div
                key={index}
                className="relative flex items-center w-full max-w-4xl"
              >
                {/* Left-aligned text for index 0 and 2 */}
                {index === 0 || index === 2 ? (
                  <div className="flex-1 text-left transform -translate-x-6 sm:-translate-x-10 max-w-[300px] sm:max-w-[450px]">
                    <h3 className="text-2xl font-bold">{solution.title}</h3>
                    <p className="text">{solution.description}</p>
                  </div>
                ) : (
                  <div className="flex-1"></div>
                )}

                {/* Number Box with Horizontal Line Centered */}
                <div className="relative flex flex-col items-center">
                  <div
                    className="w-12 h-12 flex items-center justify-center text-white font-bold text-lg border border-white border-opacity-10 shadow-md relative z-10 rounded-[10px]"
                    style={{ backgroundColor: "#6B697D" }}
                  >
                    {solution.number}
                  </div>

                  <div
                    className={`absolute top-1/2 w-16 h-[2px] bg-gray-500 ${
                      index === 1
                        ? "left-[calc(30%+5px)]"
                        : "right-[calc(30%+5px)]"
                    }`}
                  ></div>
                </div>

                {/* Right-aligned text for index 1 */}
                {index === 1 ? (
                  <div className="flex-1 text-left transform translate-x-10 max-w-[300px] sm:max-w-[450px]">
                    <h3 className="text-2xl font-bold">{solution.title}</h3>
                    <p className="text">{solution.description}</p>
                  </div>
                ) : (
                  <div className="flex-1"></div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="client-success-section bg-[#F1EBFB] py-16 px-6 md:px-12">
        <div className="client-success-container max-w-6xl mx-auto">
          {/* Image Section */}
          <div className="client-image flex justify-center mb-10">
            <img
              src={clientSuccess}
              alt="Client Success"
              className="client-image-img w-full max-w-md md:max-w-lg"
            />
          </div>

          {/* Content Section */}
          <div className="client-content">
            <h2 className="client-heading text-2xl md:text-3xl font-bold text-center text-gray-800 mb-10">
              Propalz.com: Revolutionizing Recruitment for Consultancies,
              Companies & Candidates{" "}
            </h2>

            <div className="client-stories flex flex-col">
              {successStories.map((story, index) => (
                <div
                  key={index}
                  className="story-item flex flex-col md:flex-row items-center md:items-start gap-4 md:gap-6"
                >
                  {/* SVG Arrow with Number Inside */}
                  <svg
                    width="150"
                    height="120"
                    viewBox="0 0 90 132"
                    xmlns="http://www.w3.org/2000/svg"
                    className="story-arrow w-20 md:w-24"
                  >
                    <path
                      d="M 0 114.515625 L 45 132.515625 L 90 114.515625 L 90 0 L 45 18 L 0 0 Z"
                      fill="#F1EBFB"
                      strokeWidth="0.5"
                      stroke="#6B697D"
                    />
                    <text
                      x="50%"
                      y="55%"
                      textAnchor="middle"
                      dominantBaseline="middle"
                      fontSize="24"
                      fontWeight="bold"
                      fill="#6B697D"
                    >
                      {index + 1}
                    </text>
                  </svg>

                  {/* Text beside SVG */}
                  <div className="flex-1 text-center md:text-left">
                    <h3 className="story-title text-lg md:text-xl font-semibold text-gray-900">
                      {story.title}
                    </h3>
                    <p className="story-description text-gray-700">
                      {story.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="bg-[linear-gradient(150deg,#b2f07b,#d9feb9,#a4f35f)]  py-16 px-4 text-center relative">
        <h2 className="text-4xl md:text-5xl font-bold mb-8 text-[#231971]">
          Why Choose DigiCloud Tech Services?
        </h2>

        <div className="flex justify-center items-center relative">
          {/* SVG Circle */}
          <div className="relative w-[300px] md:w-[400px] h-[300px] md:h-[400px]">
            <svg
              width="100%"
              height="100%"
              viewBox="-0.6 -0.6 1.2 1.2"
              className="relative"
            >
              {/* Arrows */}
              <path
                d="M -0.258 0.428 L -0.265 0.248 L -0.108 0.168 A 0.2 0.2 0 0 1 -0.108 -0.168 L -0.099 -0.344 L -0.258 -0.428 A 0.5 0.5 0 0 0 -0.258 0.428 Z"
                fill="#3ea3f9"
                stroke="white"
                strokeWidth="0.001"
              />
              <path
                d="M -0.258 0.428 L -0.265 0.248 L -0.108 0.168 A 0.2 0.2 0 0 1 -0.108 -0.168 L -0.099 -0.344 L -0.258 -0.428 A 0.5 0.5 0 0 0 -0.258 0.428 Z"
                fill="#3ea3f9"
                stroke="white"
                strokeWidth="0.001"
                transform="rotate(90)"
              />
              <path
                d="M -0.258 0.428 L -0.265 0.248 L -0.108 0.168 A 0.2 0.2 0 0 1 -0.108 -0.168 L -0.099 -0.344 L -0.258 -0.428 A 0.5 0.5 0 0 0 -0.258 0.428 Z"
                fill="#3ea3f9"
                stroke="white"
                strokeWidth="0.001"
                transform="rotate(180)"
              />
              <path
                d="M -0.258 0.428 L -0.265 0.248 L -0.108 0.168 A 0.2 0.2 0 0 1 -0.108 -0.168 L -0.099 -0.344 L -0.258 -0.428 A 0.5 0.5 0 0 0 -0.258 0.428 Z"
                fill="#3ea3f9"
                stroke="white"
                strokeWidth="0.001"
                transform="rotate(270)"
              />

              {/* Numbers */}
              <g
                fontSize="0.08"
                fontWeight="bold"
                fill="black"
                textAnchor="middle"
              >
                <text x="-0.10" y="0.00">
                  1
                </text>
                <text x="0.20" y="-0.30">
                  2
                </text>
                <text x="0.55" y="0.00">
                  3
                </text>
                <text x="0.20" y="0.35">
                  4
                </text>
              </g>
            </svg>
          </div>

          {/* External Text Labels */}
          <div className="absolute inset-0">
            {/* Research & Development */}
            <div className="absolute left-[-4%] sm:left-[30%] top-[45%] sm:top-[50%] bg-[#231971]font-bold text-sm sm:text-lg md:text-xl lg:text-2xl flex flex-col sm:flex-row">
              <span>Innovation</span>
            </div>

            {/* Cutting-Edge Technologies */}
            <div className="absolute left-[30%] sm:left-[45%] top-[0%] sm:top-[0%] bg-[#231971]font-bold text-sm sm:text-lg md:text-xl lg:text-2xl">
              Customer-Centric{" "}
            </div>

            {/* Continuous Improvement */}
            <div className="absolute left-[85%] sm:left-[62%] top-[40%] sm:top-[50%] bg-[#231971]font-bold text-sm sm:text-lg md:text-xl lg:text-2xl">
              Expertise{" "}
            </div>

            {/* Customer Satisfaction */}
            <div className="absolute left-[35%] sm:left-[45%] top-[95%] sm:top-[95%] bg-[#231971]font-bold text-sm sm:text-lg md:text-xl lg:text-2xl">
              Results-Driven
            </div>
          </div>
        </div>

        <p className="mt-4 text-lg text-black/80">
          DigiCloud is committed to results-driven, customer-centric solutions
          that empower businesses to grow.
        </p>
      </section>

      <section>
        <div className="bg-[linear-gradient(150deg,#67b4f8,#afd6f9,#3ea3f9)] p-6 md:p-16">
          {/* Careers Section */}
          <div className="max-w-5xl mx-auto p-4 md:p-10 rounded-2xl">
            <h2 className="text-3xl md:text-6xl font-bold text-[#231971] mb-6 md:mb-8 text-left">
              Empower your future: Innovate, code, and grow with us.
            </h2>

            {/* Vertical Stacked Boxes */}
            <div className="flex flex-col items-start space-y-6 w-full">
              {[
                {
                  id: 1,
                  title: "Jr. AI Developer",
                  positions: "3 Positions",
                  width: "30%",
                },
                {
                  id: 2,
                  title: "Jr. Software Developer",
                  positions: "13 Positions",
                  width: "60%",
                },
                {
                  id: 3,
                  title: "Sales Associate",
                  positions: "5 Positions",
                  width: "40%",
                },
              ].map((career, index) => (
                <div key={career.id} className="w-full">
                  <div className="flex flex-col md:flex-row items-start md:items-center">
                    {/* Dynamic Number Box */}
                    <div
                      className="h-[60px] flex items-center border border-gray-400 bg-[#e3e3e3] text-[#292742] text-lg md:text-xl font-bold rounded-xl px-4"
                      style={{
                        width: career.width,
                        minWidth: "150px", // Ensures a minimum size for small screens
                        maxWidth: "600px", // Prevents excessive growth on large screens
                        justifyContent: "flex-start",
                      }}
                    >
                      {career.title}
                    </div>

                    {/* Career Title */}
                    <span className="ml-0 md:ml-4 font-semibold text-lg md:text-xl text-gray-800 mt-2 md:mt-0">
                      {career.positions}
                    </span>
                  </div>

                  {/* Connecting Line (Only for first two items) */}
                  {index < 2 && (
                    <div
                      className="border-t border-gray-400 mt-3 hidden md:block"
                      style={{
                        marginLeft: `calc(${career.width} + 50px)`,
                        width: "calc(100% - 300px)",
                      }}
                    ></div>
                  )}
                </div>
              ))}
            </div>

            {/* Description */}
            <p className="mt-6 text-gray-700 text-left text-base md:text-lg">
              ​Join our innovative team and lets us code the future of
              technology.
            </p>
          </div>
          <div className="p-8 bg-[linear-gradient(150deg,#b2f07b,#d9feb9,#a4f35f)]  text-white rounded-2xl shadow-lg text-center">
            <h2 className="text-3xl font-bold mb-4 text-[#231971]">
              Contact Us: Get Started with DigiCloud Tech Services Today
            </h2>
            <ContactUs className="btn-4" />
          </div>
        </div>
      </section>
    </div>
  );
};

export default Digicloud;
